import { parseCivilDate } from '@klopotun/domain';

const pluralRules = new Intl.PluralRules('uk-UA');

const DAY_WORD: Record<Intl.LDMLPluralRule, string> = {
  zero: 'днів',
  one: 'день',
  two: 'дні',
  few: 'дні',
  many: 'днів',
  other: 'дня',
};

const UNPAID_WORDS: Record<Intl.LDMLPluralRule, string> = {
  zero: 'неоплачених платежів',
  one: 'неоплачений платіж',
  two: 'неоплачені платежі',
  few: 'неоплачені платежі',
  many: 'неоплачених платежів',
  other: 'неоплаченого платежу',
};

const NAMED_DAY: Record<number, string> = {
  0: 'сьогодні',
  1: 'завтра',
};

const padded = (value: number): string => String(value).padStart(2, '0');

export const formatDayCount = (days: number): string =>
  `${String(days)} ${DAY_WORD[pluralRules.select(days)]}`;

export const formatUnpaidCount = (count: number): string =>
  `${String(count)} ${UNPAID_WORDS[pluralRules.select(count)]}`;

export const formatDaysAhead = (days: number): string =>
  NAMED_DAY[days] ?? `через ${formatDayCount(days)}`;

export const capitaliseFirst = (text: string): string =>
  `${text.charAt(0).toLocaleUpperCase('uk-UA')}${text.slice(1)}`;

export const formatDayAndMonth = (value: string): string => {
  const date = parseCivilDate(value);

  return `${padded(date.day)}.${padded(date.month)}`;
};
